import {useCallback, useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import hbricon from "../otherImg/hbrlitenewicon.png";
import BookContent from "./BookContent";
import { get, limitToFirst, limitToLast, off, onValue, orderByKey, query, ref, set} from "firebase/database";
import db, { realTimeDB } from "../firebase";
import { customFuzzySearch, insertBookAnalytics, ItemID, LavensteinAlgorithm, PurifyTextUtils, ShortenText } from "../newComponents/GeneralClasses";
import { Hbrbackarrow, HbrCancel, HbrSearchIcon, HbrSortIcon, HbrStarIcon} from "../newComponents/Mycustomsvgicons";
import { actionConsts, reducer } from "../newComponents/StateManager";
import UseLayout from "../newComponents/useLayout";
import { format } from "date-fns";
import SearchHistory from "../newComponents2/SearchHistory";
import { collection, limit, onSnapshot, orderBy, query as docQuery, startAfter, setDoc, doc} from "firebase/firestore";
import ReviewContent from "../newComponents2/ReviewContent";
import { AuthContext } from "../AuthContext";
import { CountryWithFlags } from "../newComponents2/EmojisUnicode";
import RatingStar from "../newComponents2/RatingStar";
import AddToNotificationDB from "../newComponents2/AddToNotificationDB";
import { ConstVariables } from "../newComponents2/ConstantVariables";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { useLocation, useNavigate } from "react-router-dom";

const EnglishBksHome = () => {
  const [searchValue,setSearchValue] = useState("");
  const [IsSearchUnique, setIsSearchUnique] =useState(true);
  const [isSearching, setIsSearchEvent] = useState(false);
  const [books,setBooks] = useState([]);
  const [ispending,setIsPending]=useState(true);
  const [matchFound,setMatchFound] = useState(null);
  const [showMoreBtn, setIsShowMoreBtn] = useState(false);
  const [showSortingList, setShowSortingList] = useState(false);
  const [lastFetchedBookKey,setLastBookKey] = useState(null);
  const [state,dispatch] = useReducer(reducer,{progressIndicator: false, openBottomSheet: false, bookTitle: "", reviewerName: "", country: "", message:"",showCountryList: false, sendingTask: false, showAlert: false, alertMessage: ""});
  const [fillStar, setFillStars] = useState([false, false, false, false, false]);
  const [sortTypeSelected,setSortTypeSelected] = useState(null);
  const [searchListHistory, setSearchListHistory] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [showReviews, setShowReviews] = useState(false);
  const [showMoreReviewsBtn, setShowMoreReviewsBtn] = useState(true);
  const [lastReviewDoc, setLastReviewDoc] = useState("");
  const [ratings, setRatings] = useState([]);
  const collectionRef = collection(db, "book reviews");
  const {width} = UseLayout();
  const {userName} = useContext(AuthContext);
  const {user_email} = useContext(AuthContext);
  const searchHistory_id = format(new Date(),"yyyyMMddHHmmss");
  let THRESHOLD = 500;
  const [searchTotals, setSearchTotal] = useState(0);
  const sortTabRef = useRef(null);
  const countryListRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const skipCommonWords = useMemo(()=>["the", "and", "is", "for", "his", "her", "a", "an", "of", "in", "to", "with", "on", "at", "by",
      "from", "up", "down", "out", "over", "under", "again", "further", "then"
    ],[]);
  const newPublishID = "nphbr1001";
  const newBooksID = "nbhbr1002";
  const classicsID = "clhbr1003";
  const sortingList =useMemo(()=>["Default (A - Z)", "Most read", "Most shared", "Most rated", "Most bookmarked", "Newly published", "New books", "Classic books"],[]);



  useEffect(()=>{
    const fetchBooksWhenComponentMount=async()=>{
      const bookStatsSnapshot = await get(ref(realTimeDB,"bookStats"));
      const booksSnapShot = await get(query(ref(realTimeDB,"Books english"), limitToFirst(20)));
      if (booksSnapShot.exists() && bookStatsSnapshot.exists()) {
        const listOfBooks = booksSnapShot.val();
        const bookStatsData = bookStatsSnapshot.val();

        const arrayOfBooks = Object.keys(listOfBooks).map((key)=>({
          id: key,

          ...listOfBooks[key],

          reads: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.reads ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].reads : 0,

          shares: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.shares ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].shares : 0,

          bookmarks: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.bookmarks ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].bookmarks : 0,

          rate: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.rate ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].rate : 0
        }));
  
        const sortedBooks = arrayOfBooks?.sort((a,b) => a.name.localeCompare(b.name));
        setBooks(sortedBooks);
        setLastBookKey(arrayOfBooks[arrayOfBooks?.length-1]?.id);
        setIsPending(false);
        setIsShowMoreBtn(true);
      }
    };

    fetchBooksWhenComponentMount();
  },[]);
  const memoizedBooks = useMemo(()=>books,[books]);

  const fetchMoreBooks=async()=>{
    setIsPending(true);
    const bookStatsSnapshot = await get(ref(realTimeDB,"bookStats"));
    const booksSnapShot = await get(query(ref(realTimeDB,"Books english"),orderByKey(),startAfter(lastFetchedBookKey), limitToFirst(20)));
    const listOfBooks = booksSnapShot.val();
    
      const bookStatsData = bookStatsSnapshot.val();
      if (listOfBooks) {
        const arrayOfBooks = Object.keys(listOfBooks).map((key)=>({
          id: key,
  
          ...listOfBooks[key],
  
          reads: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.reads ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].reads : 0,
  
          shares: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.shares ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].shares : 0,
  
          bookmarks: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.bookmarks ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].bookmarks : 0,
  
          rate: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.rate ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].rate : 0
        }));
        const sortedBooks = arrayOfBooks?.sort((a,b) => a.name.localeCompare(b.name));
        setBooks(prev => [...prev, ...sortedBooks]);
        setLastBookKey(arrayOfBooks[arrayOfBooks?.length-1]?.id);
        setIsPending(false);
      }else{
        setLastBookKey(null);
        setIsShowMoreBtn(false);
        setIsPending(false);
      }
  };

  const handleSort=(sortType)=>{
    if (sortType === null) {
      memoizedBooks.sort((a,b) => a.name.localeCompare(b.name));
      setIsShowMoreBtn(true);
      return;
    }
    if (sortType === "Most read") {
      memoizedBooks.sort((a,b) => b.reads - a.reads);
      setIsShowMoreBtn(true);
    }
    if (sortType === "Most rated") {
      memoizedBooks.sort((a,b) => b.rate - a.rate);
      setIsShowMoreBtn(true);
    }
    if (sortType === "Most bookmarked") {
      memoizedBooks.sort((a,b) => b.bookmarks - a.bookmarks);
      setIsShowMoreBtn(true);
    }
    if (sortType === "Most shared") {
      memoizedBooks.sort((a,b) => b.shares - a.shares);
      setIsShowMoreBtn(true);
    }

    if (sortType === "Newly published") {
        fetchBookByPublication(newPublishID, null);
        setIsShowMoreBtn(false);
    }
    if (sortType === "Classic books") {
        fetchBookByPublication(classicsID, null);
        setIsShowMoreBtn(false);
    }
    if (sortType === "New books") {
        fetchBookByPublication(newBooksID, newPublishID);
        setIsShowMoreBtn(false);
    }
    if (sortType === "Default (A - Z)") {
      memoizedBooks.sort((a,b) => a.name.localeCompare(b.name));
      setIsShowMoreBtn(true);
    }
    setSortTypeSelected(sortType);
  };

  const handleSearch=async(e)=>{
    e.preventDefault();
    if (searchValue === "") {
      return alert("search field cannot be empty");
    }
    setIsSearchEvent(false)
    let foundBooks = [];
    dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
    const bookStatsSnapshot = await get(ref(realTimeDB,"bookStats"));
    const booksSnapShot = await get(ref(realTimeDB,"Books english"));
    setBooks([]);
    const addedBookID = new Set();

    const listOfBooks = booksSnapShot.val();
    const bookStatsData = bookStatsSnapshot.val();
    const keyWords = searchValue.split(",");

          for(const key in listOfBooks){
            let bookTitle = listOfBooks[key]?.name;
            const distance = LavensteinAlgorithm(bookTitle, searchValue);
            if (distance <= THRESHOLD && !addedBookID.has(key)) {
              for(const keyword of keyWords){
                const cleanKeyword = keyword.trim().toLocaleLowerCase();
                if (!skipCommonWords.includes(cleanKeyword) && bookTitle.toLocaleLowerCase().includes(cleanKeyword)) {
                  let matchBook = {
                    id: key,
    
                    ...listOfBooks[key],
    
                    distance,
          
                    reads: bookStatsData[PurifyTextUtils(bookTitle)].reads ? bookStatsData[PurifyTextUtils(bookTitle)].reads : 0,
          
                    shares: bookStatsData[PurifyTextUtils(bookTitle)].shares ? bookStatsData[PurifyTextUtils(bookTitle)].shares : 0,
          
                    bookmarks: bookStatsData[PurifyTextUtils(bookTitle)].bookmarks ? bookStatsData[PurifyTextUtils(bookTitle)].bookmarks : 0,
          
                    rate: bookStatsData[PurifyTextUtils(bookTitle)].rate ? bookStatsData[PurifyTextUtils(bookTitle)].rate : 0
                  }
                  foundBooks.push(matchBook);
                  addedBookID.add(key);
                }
              }
           
                // for(const keyword of keyWords){
                //   const cleanKeyword = String(keyword).toLowerCase().trim();
                //   if (!unnecessaryKeyWords.includes(cleanKeyword) && !addedBookID.has(key)) {
                //     if (bookTitle.toLowerCase().includes(cleanKeyword)) {
                //       let matchBook = {
                //         id: key,
      
                //         ...listOfBooks[key],

                //         distance,
              
                //         reads: bookStatsData[PurifyTextUtils(bookTitle)].reads ? bookStatsData[PurifyTextUtils(bookTitle)].reads : 0,
              
                //         shares: bookStatsData[PurifyTextUtils(bookTitle)].shares ? bookStatsData[PurifyTextUtils(bookTitle)].shares : 0,
              
                //         bookmarks: bookStatsData[PurifyTextUtils(bookTitle)].bookmarks ? bookStatsData[PurifyTextUtils(bookTitle)].bookmarks : 0,
              
                //         rate: bookStatsData[PurifyTextUtils(bookTitle)].rate ? bookStatsData[PurifyTextUtils(bookTitle)].rate : 0
                //       }
                //       foundBooks.push(matchBook);
                //       addedBookID.add(key);
                //     }
                //   }
                // }
            }
        }
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
        let isSearchBookFound = foundBooks.length === 0 ? false : true;
        setMatchFound(isSearchBookFound);

        foundBooks.sort((a,b) => a.distance - b.distance);
        // setBooks(foundBooks.slice(0,10));
        setBooks(foundBooks);
        //TODO: paginate the foundbooks to fetch results bit by bit

        if (isSearchBookFound && IsSearchUnique) {
          set(ref(realTimeDB, `search history/${searchHistory_id}`),{
            searchItem: PurifyTextUtils(searchValue)
          });
        }
        setSearchValue("");
        setSearchTotal(foundBooks.length);
        setIsSearchUnique(true);
  };

  const fetchBookByPublication=async(pubTypeMain, pubTypeSub)=>{
    dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
    const bookStatsSnapshot = await get(ref(realTimeDB,"bookStats"));
    const booksSnapShot = await get(ref(realTimeDB,"Books english"));
    setBooks([]);
    let foundBooks = [];
    const addedBookID = new Set();

    const listOfBooks = booksSnapShot.val();
    const bookStatsData = bookStatsSnapshot.val();

    for(const key in listOfBooks){
        let bookTitle = listOfBooks[key].name
        let publish_id = listOfBooks[key].publishID;
        if (!addedBookID.has(key) && pubTypeSub !== null) {
          if (publish_id.includes(pubTypeMain) || publish_id.includes(pubTypeSub)) {
            let matchBook = {
              id: key,
  
              ...listOfBooks[key],
    
              reads: bookStatsData[PurifyTextUtils(bookTitle)]?.reads ? bookStatsData[PurifyTextUtils(bookTitle)].reads : 0,
    
              shares: bookStatsData[PurifyTextUtils(bookTitle)]?.shares ? bookStatsData[PurifyTextUtils(bookTitle)].shares : 0,
    
              bookmarks: bookStatsData[PurifyTextUtils(bookTitle)]?.bookmarks ? bookStatsData[PurifyTextUtils(bookTitle)].bookmarks : 0,
    
              rate: bookStatsData[PurifyTextUtils(bookTitle)]?.rate ? bookStatsData[PurifyTextUtils(bookTitle)].rate : 0
            }
            foundBooks.push(matchBook);
            addedBookID.add(key);
          }
        }else{
          if (publish_id.includes(pubTypeMain)) {
            let matchBook = {
              id: key,
  
              ...listOfBooks[key],
    
              reads: bookStatsData[PurifyTextUtils(bookTitle)]?.reads ? bookStatsData[PurifyTextUtils(bookTitle)].reads : 0,
    
              shares: bookStatsData[PurifyTextUtils(bookTitle)]?.shares ? bookStatsData[PurifyTextUtils(bookTitle)].shares : 0,
    
              bookmarks: bookStatsData[PurifyTextUtils(bookTitle)]?.bookmarks ? bookStatsData[PurifyTextUtils(bookTitle)].bookmarks : 0,
    
              rate: bookStatsData[PurifyTextUtils(bookTitle)]?.rate ? bookStatsData[PurifyTextUtils(bookTitle)].rate : 0
            }
            foundBooks.push(matchBook);
            addedBookID.add(key);
          }
        }
    }
    dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
    setMatchFound(null);
    setLastBookKey(null);
    setBooks(foundBooks.sort((a,b)=> a.name.localeCompare(b.name)));
  };

  useEffect(()=>{
    if (!isSearching) {
      return;
    }
    const historyRef = query(ref(realTimeDB,"search history"),orderByKey(), limitToLast(150));
    const historyListener = onValue(historyRef, (snapshot)=>{
      if (snapshot.exists()) {
        const fetchedHistory = snapshot.val();
        if (fetchedHistory) {
               const recentSearchResults = Object.entries(fetchedHistory).map(([key, value]) => ({
          id: key,
          ...value,
        }));
        setSearchListHistory(recentSearchResults);
        }
      }
    });
    return()=> off(historyRef, historyListener);
  },[isSearching]);

  const memoizedSearches = useMemo(()=>{
    if (searchValue === "")return searchListHistory;
    
    return customFuzzySearch(searchValue, searchListHistory);
  },[searchListHistory, searchValue]);

  const handleSearchHistoryItemSelected=useCallback((searchItem)=>{
    if(searchItem){
      setSearchValue(searchItem);
      setIsSearchUnique(false);
      setIsSearchEvent(false);
    }
  },[]);

  useEffect(()=>{
    if (isSearching || showSortingList || state.showCountryList) {
      // const closeSearchSuggestionTab=(e)=>{
      //   if (searchInputRef.current) {
      //     if (!searchInputRef.current.contains(e.target)) {
      //       setIsSearchEvent(false);
      //     }
      //   }
      // };
      const closeSortTab=(e)=>{
        if (sortTabRef.current) {
          if (!sortTabRef.current.contains(e.target)) {
            setShowSortingList(false);
          }
        }
      };
      const closeCountryList=(e)=>{
        if (countryListRef.current) {
          if (!countryListRef.current.contains(e.target)) {
            dispatch({type: actionConsts.SHOW_COUNTRIES, payload: false});
          }
        }
      };
      
      // document.addEventListener('mousedown', closeSearchSuggestionTab);
      document.addEventListener('mousedown', closeSortTab);
      document.addEventListener("mousedown", closeCountryList);

      return()=>{
        // document.removeEventListener('mousedown', closeSearchSuggestionTab);
        document.removeEventListener('mousedown', closeSortTab);
        document.removeEventListener("mousedown", closeCountryList);
      }
    }

  },[isSearching, showSortingList, state.showCountryList]);

  const fetchReviews=()=>{
    setShowReviews(true);
    dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
    const q = docQuery(collectionRef, orderBy("timestamp","desc"), limit(10));
    const unsub = onSnapshot(q, (snapshot)=>{
        const newReviewsArray = [];
        snapshot.forEach((doc)=>{
            newReviewsArray.push(doc.data());
        });
        setReviews(newReviewsArray);
        setLastReviewDoc(snapshot.docs[snapshot.docs.length -1]);
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
    });
    return unsub;
  };
  const memoizedReviews = useMemo(()=>reviews, [reviews]);

  const fetchMoreReviews=()=>{
      dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
      const q = docQuery(collectionRef, orderBy("timestamp","desc"), startAfter(lastReviewDoc), limit(10));
      const unsub = onSnapshot(q, (snapshot)=>{
          const moreReviewsArray = [];
          snapshot.forEach((doc)=>{
              moreReviewsArray.push(doc.data());
          });
          if (moreReviewsArray.length === 0) {
            setShowMoreReviewsBtn(false);
            return alert("end of reviews");
          }
          setReviews(prev => [...prev, ...moreReviewsArray]);
          setLastReviewDoc(snapshot.docs[snapshot.docs.length -1]);
          dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
      });
      return unsub; 
  };

  const getBookTitleForReview=(bookTitle)=>{
    dispatch({type: actionConsts.BOOKTITLE, payload: bookTitle});
    dispatch({type: actionConsts.OPEN_BOTTOM_SHEET});
  };

  const handlePostReview=async()=>{
    if (state.message === "") {
      dispatch({type: actionConsts.SHOWALERT, payload: true});
      dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Empty reviews are disallowed. Write your review in the text field below the rating stars before posting. Describe your experience on reading the selected book."});
      return;
    }

    dispatch({type: actionConsts.SENDING_TASK, payload: true});
    const reviewID = ItemID();
    const timestamp = new Date().getTime();
    const nameTosend = userName && userName !== "" ? userName : state.reviewerName;
      await setDoc(doc(db, "book reviews",reviewID),{
        name: userName && userName !== "" ? userName : state.reviewerName,
        email: user_email,
        message: state.message,
        book_title: state.bookTitle,
        country: state.country,
        personImage: "",
        rate: ratings,
        timestamp: timestamp,
        reviewID: reviewID
      });
      const notificationText = `${nameTosend} has written a new review on the book ${state.bookTitle}: ${ShortenText(state.message, 50)}`
      AddToNotificationDB(
        ConstVariables.REVIEWS_TITLE, 
        notificationText, 
        ConstVariables.DUMMI_IMAGE,
         reviewID, 
         "", 
         ConstVariables.REVIEWS_TOPIC,
         user_email
      );
      insertBookAnalytics(state.bookTitle, ConstVariables.RATE, ratings.length);
      dispatch({type: actionConsts.SENDING_TASK, payload: false});
      dispatch({type: actionConsts.REVIEWER_NAME, payload: ""});
      dispatch({type: actionConsts.COUNTRY, payload: ""});
      dispatch({type: actionConsts.MESSAGE, payload: ""});
      setFillStars([false, false, false, false, false]);
  };

  const handleStarClick = (starIndex) => {
    // dispatch({ type: actionConsts[`STAR${starIndex + 1}`] });
    const newRating = `star${'⭐'.repeat(starIndex + 1)}`;
    const newRatings = [...ratings];
    const index = newRatings.indexOf(newRating);
  
    if (index !== -1) {
      // Remove the star if it's already present
      newRatings.splice(index, 1);
    } else {
      // Add the star if it's not present
      newRatings.push(newRating);
    }
    setRatings(newRatings);
    const newFillStars = [...fillStar];
    newFillStars[starIndex] = !newFillStars[starIndex];
    setFillStars(newFillStars);
  };

  const closeBottomSheet=()=>{
    setRatings([]);
    dispatch({type: actionConsts.OPEN_BOTTOM_SHEET});
    dispatch({type: actionConsts.SENDING_TASK, payload: false});
    dispatch({type: actionConsts.REVIEWER_NAME, payload: ""});
    dispatch({type: actionConsts.COUNTRY, payload: ""});
    dispatch({type: actionConsts.MESSAGE, payload: ""});
    setFillStars([false, false, false, false, false]);
  };

  const handleOnCountrySelected=(name, flag)=>{
    dispatch({type: actionConsts.COUNTRY, payload: `${name} ${flag}`});
    dispatch({type: actionConsts.SHOW_COUNTRIES, payload: false});
  };

  const handleCloseAlert=(data)=>{
    if(data === "close"){
        dispatch({type: actionConsts.SHOWALERT, payload: false});
    }
  };
  
  const closePage=()=>{
    if (location.state && location.state.from) {
        navigate(location.state.from);
    }else{
        navigate("/");
    }
  };




    return (  
        <div className="homeenglishbooks">

          {state.showAlert &&
              <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert} />
          }

          {state.progressIndicator && 
            <div className="linearprogressindicator">
              <div className="linearprogressbar"></div>
            </div>
          }
        
            {ispending && 
              <div className='flex-column2' style={{position:"fixed",top:"30%",left:"40%"}}> 
                  <div style={{
                      width:"80px",
                      height:"80px",
                      border: "5px solid white",
                      borderTop: "5px solid #eb268f",
                      borderBottom: "5px solid Teal",
                      borderRadius: "50%",
                      animation: "spin2 2s linear infinite",
                      zIndex:"2"
                      }}>
                  </div>
                  <h3>Fetching books...</h3>
              </div>
            }  

            <div className="search-field">
                  <div className="flex-row2" style={{gap:"10px"}}>
                    <Hbrbackarrow width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>closePage()}/>
                    <h3>Books {books?.length}</h3>
                </div>
                 

                  <div className="flex-row2" style={{gap:"5px", cursor:"pointer",position:"relative",background:"#efefef",borderRadius:"999px",padding:"10px"}} 
                                            onClick={() => setShowSortingList(prev => !prev)}>

                    <HbrSortIcon width={"1.5em"} height={"1.5em"} fillColour={"black"}/>
                    <p id={`${sortTypeSelected ? 'sortactive' : ''}`} style={{fontWeight:"bold"}}>
                      {`Sort ${sortTypeSelected ? ': ' + sortTypeSelected : ''}`}
                    </p>

                  {showSortingList && (
                    <div className="booksortmenu flex-column2" style={{gap:"10px", borderRadius:"10px", background:"white",}} ref={sortTabRef}>
                        {sortingList.map((sortType,index) =>(
                          <button key={index} style={{border:"none", fontWeight:"bold", cursor:"pointer"}}
                                  onClick={()=>handleSort(sortType)}>
                            {sortType}
                          </button>
                        ))}
                    </div>
                  )}
                  </div>

                  <form className="flex-row2" style={{width:"30%",position:"relative"}} onSubmit={handleSearch} >
                      <input 
                      type="text" 
                      placeholder="search" 
                      value={searchValue} 
                      onChange={e => setSearchValue(e.target.value)} 
                      onFocus={()=>setIsSearchEvent(true)}/>

                      <div style={{borderTopRightRadius:"50%",borderBottomRightRadius:"50%",border:"1px solid black",padding:"8px",cursor:"pointer"}} onClick={(e)=>handleSearch(e)}>
                          <HbrSearchIcon width={"1.3em"} height={"1.3em"} fillColour={"black"}/>
                      </div>

                      {isSearching && memoizedSearches && 
                        <div className="searchhistorytab flex-column1">
                          <h5 style={{background:"#efefef"}}>{`Recent Searches(${memoizedSearches.length})`}</h5>
                            {memoizedSearches.map((data,index)=>(
                              <SearchHistory 
                                key={index}
                                item_id={data.id}
                                searchItem={data.searchItem}
                                handleClick={handleSearchHistoryItemSelected}
                              />
                            ))}
                        </div>
                      }
                  </form>

                  <div className="flex-row2" style={{gap:"5px", cursor:"pointer",background:"#efefef",borderRadius:"999px",padding:"10px"}}>
                      <button style={{fontWeight:"bold", border:"none", backgroundColor:"transparent",cursor:"pointer", caretColor:"transparent"}} onClick={()=>fetchReviews()}>
                        Reviews
                      </button>
                        <HbrStarIcon width={"1.5em"} height={"1.5em"} fillColour={"orange"}/>
                  </div>

                  <div className="pagetoplogo">
                        <img src={hbricon} alt=""/>
                  </div>

            </div>

            <div className="search-field-phone flex-column2">
                  <div style={{width:"100%",height:"2em", position:"relative", marginTop:"10px"}}>

                        <div style={{width:"2em",height:"2em",borderRadius:"50%",objectFit:"cover",position:"absolute",left:"10px",top:"0px"}}>
                        <Hbrbackarrow width={"1.7em"} height={"1.7em"} fillColour={"black"} handleClick={()=>closePage()}/>
                        </div>

                        <img src={hbricon} alt="" style={{width:"2em",height:"2em",borderRadius:"50%",objectFit:"cover",position:"absolute",right:"10px",top:"0px"}}/>

                        <h3 style={{position:"absolute",right:`${width <= 500 ? '30%': '40%'}`,top:"0px"}}>Online Books</h3>
                  </div>

                   <form className="flex-row2" style={{width:"100%",position:"relative"}} onSubmit={handleSearch} onClick={() => setShowSortingList(false)}>
                   <input 
                      type="text" 
                      placeholder="search" 
                      value={searchValue} 
                      onChange={e => setSearchValue(e.target.value)} 
                      onFocus={()=>setIsSearchEvent(true)}/>

                      <div style={{borderTopRightRadius:"50%",borderBottomRightRadius:"50%",border:"1px solid black",padding:"7px",cursor:"pointer"}} onClick={(e)=>handleSearch(e)}>
                          <HbrSearchIcon width={"1.2em"} height={"1.2em"} fillColour={"black"}/>
                      </div>

                      {isSearching && memoizedSearches && 
                        <div className="searchhistorytab flex-column1">
                          <h5 style={{background:"#efefef"}}>{`Recent Searches(${memoizedSearches.length})`}</h5>
                            {memoizedSearches.map((data,index)=>(
                              <SearchHistory 
                                key={index}
                                item_id={data.id}
                                searchItem={data.searchItem}
                                handleClick={handleSearchHistoryItemSelected}
                              />
                            ))}
                        </div>
                      }
                  </form>

                  <div className="flex-spacebetween" style={{width:"100%", marginTop:"8px", marginBottom:"8px"}}>
                      <div style={{gap:"5px", cursor:"pointer",position:"relative", maxWidth:"50%"}} onClick={() => setShowSortingList(prev => !prev)}>
                          <div className="flex-row2" style={{background:"#efefef",borderRadius:"999px",padding:"8px"}}>
                              <HbrSortIcon width={"1.5em"} height={"1.5em"} fillColour={"black"}/>
                              <p id={`${sortTypeSelected ? 'sortactive' : ''}`} style={{fontWeight:"bold"}}>
                                {`Sort ${sortTypeSelected ? ': ' + sortTypeSelected : ''}`}
                              </p>
                          </div>

                          {showSortingList && (
                            <div className="booksortmenu flex-column2" style={{gap:"10px", borderRadius:"10px", background:"white",}}>
                                {sortingList.map((sortType,index) =>(
                                  <button key={index} style={{border:"none", fontWeight:"bold", cursor:"pointer"}}
                                          onClick={()=>handleSort(sortType)}>
                                    {sortType}
                                  </button>
                                ))}
                            </div>
                          )}
                      </div>

                        <div className="flex-row2" style={{gap:"5px", cursor:"pointer", maxWidth:"45%",background:"#efefef",borderRadius:"999px",padding:"8px", caretColor:"transparent"}} onClick={()=>fetchReviews()}>
                            <HbrStarIcon width={"1.5em"} height={"1.5em"} fillColour={"orange"}/>
                            <p style={{fontWeight:"bold"}}>Reviews</p>
                      </div>
                  </div>
            </div>

              {matchFound !== null && 
                (
                  <div style={{marginLeft:"20%"}}>
                    {matchFound === false ? 
                    (<p style={{fontWeight:"bold"}}>{`Search results (0). Check the spelling or Try a more broader search.`}</p>)
                    : (<p style={{fontWeight:"bold"}}>{`Search results (${searchTotals})`}</p>)
                    }
                </div>
                )
              }
             
              <div className="fetchedBooks">
                  {memoizedBooks && memoizedBooks.map((books,index) => (
                      <BookContent
                      key={index} 
                      bookid = {books.webid}
                      bookIndex={index + 1}
                      totalBooks={memoizedBooks.length}
                      bookTitle = {books.name}
                      bookImage = {books.bookcover}
                      bookAuthor = {books.authorinfo}
                      authorpic={books.authorpic}
                      summary={books.summary}
                      reads={books.reads}
                      bookmarks={books.bookmarks}
                      rate={books.rate}
                      shares={books.shares}
                      handleReview={getBookTitleForReview}
                      />
                    ))
                  }
              </div>

              <div className={`viewreviewsheet flex-column1 ${showReviews ? 'show':'hide'}`}>

                      <div className="reviewtoptitle flex-spacebetween">
                          <span style={{fontWeight:"bold"}}>Reviews</span>
                          <HbrCancel width={"1.8em"} height={"1.8em"} fillColour={"#000000"} handleClick={()=> setShowReviews(false)}/>
                      </div>

                      <div className="viewreviewsheetcontent flex-column1">
                            {memoizedReviews && memoizedReviews.map((data, index) => (
                                    <ReviewContent 
                                    key={index}
                                    userName={data.name}
                                    email={data.email}
                                    message={data.message}
                                    book_title={data.book_title}
                                    country={data.country}
                                    rate={data.rate}
                                    timestamp={data.timestamp}
                                    reviewID={data.reviewID}
                                    />
                            ))}

                            {showMoreReviewsBtn && 
                                  <button style={{border:"none",padding:"10px",fontWeight:"bold",borderRadius:"10px",cursor:"pointer", color:"blue", backgroundColor:"white", marginBottom:"50px"}}
                                    onClick={fetchMoreReviews}>
                                  See more reviews
                                </button>
                            }
                      </div>

              </div>

              <div className={`writereviewsheet flex-column1 ${state.openBottomSheet ? 'show' : 'hide'}`}>
                      <div className="writereviewsheettop flex-spacearound">
                          <span style={{fontWeight:"bold"}}>Write your review</span>
                          <HbrCancel width={"1.8em"} height={"1.8em"} fillColour={"#000000"} handleClick={()=> closeBottomSheet()}/>
                      </div>

                      {state.sendingTask && 
                        <div className="linearprogressindicator">
                          <div className="linearprogressbar"></div>
                        </div>
                      }

                    <div className="writereviewinputfields flex-column1">
                        <button onClick={handlePostReview} disabled={state.sendingTask} >Post</button>
                        <h3>{state.bookTitle}</h3>
                        <p style={{fontWeight:"bold"}}>Reviews are public and it includes your name</p>

                        <input type="text" 
                        placeholder="Your name" 
                        value={userName && userName !== "" ? userName : state.reviewerName}
                        disabled={userName && userName !== "" ? true : false}
                        onChange={e => dispatch({type: actionConsts.REVIEWER_NAME, payload: e.target.value})}
                        />
                        
                        <div className="reviewercountryinputfield">
                            <input 
                            type="text" 
                            placeholder="country"
                            value={state.country} 
                            onFocus={()=> dispatch({type: actionConsts.SHOW_COUNTRIES, payload: true})}
                            onChange={e => dispatch({type: actionConsts.COUNTRY, payload: e.target.value})}
                            style={{width:"100%"}}
                            />

                            {state.showCountryList &&
                                <div className="showavailablecountries flex-column2" ref={countryListRef}>
                                    {CountryWithFlags && CountryWithFlags.filter((countryName) =>{
                                      const cleanSearchWord = state.country.replace(/[^\w\s]|_/g, '').toLocaleLowerCase().trim();
                                      const cleanCountryName = countryName.name.replace(/[^\w\s]|_/g, '').toLocaleLowerCase().trim();
                                      if (state.country === "") {
                                        return true;
                                      }else if (cleanCountryName.includes(cleanSearchWord)) {
                                        return true;
                                      }else{
                                        return false;
                                      }
                                    }).map((data,index)=>(
                                      <div className="countrylistitem flex-row2" style={{gap:"20px"}} key={index} 
                                        onClick={()=>handleOnCountrySelected(data?.name, data?.emoji)}>
                                        <h4>{data.name}</h4>
                                        <h5>{data.emoji}</h5>
                                      </div>
                                    ))}
                              </div>
                            }
                        </div>
                 
                        <p style={{fontWeight:"bold"}}>rate the book by clicking on the stars below</p>

                        <div className="ratingstars flex-spacearound">
                          {fillStar.map((isFilled, index)=>(
                                 <RatingStar 
                                 key={index}
                                 starIndex={index}
                                 handleClick={handleStarClick}
                                 isStarFilled={isFilled}
                               />
                          ))}
                      
                        </div>

                        <textarea
                        placeholder="Describe your experience on reading this book"
                        value={state.message}
                        rows={8}
                        onChange={e => dispatch({type: actionConsts.MESSAGE, payload: e.target.value})}
                        />
                    </div>
              </div>

              <div className="loadmorebooks">
                {showMoreBtn && 
                  (
                    <button style={{position:"absolute",top:"100%",left:"30%",border:"none",padding:"10px",fontWeight:"bold",borderRadius:"10px",cursor:"pointer"}}
                            onClick={fetchMoreBooks}>
                          More books
                    </button>
                  )
                }
              </div>
      </div>
    );
}
export default EnglishBksHome;